var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeverityInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2637 11.6073V9.18604",
    stroke: "#2F80ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2638 6.41936C10.3441 6.41936 10.421 6.38747 10.4778 6.33071C10.5346 6.27395 10.5665 6.19697 10.5665 6.1167",
    stroke: "#2F80ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96118 6.1167C9.96118 6.19697 9.99307 6.27395 10.0498 6.33071C10.1066 6.38747 10.1836 6.41936 10.2638 6.41936",
    stroke: "#2F80ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2638 5.81397C10.2241 5.81386 10.1847 5.82162 10.1479 5.83679C10.1111 5.85196 10.0777 5.87425 10.0496 5.90237C10.0215 5.9305 9.99918 5.96391 9.984 6.00068C9.96883 6.03744 9.96108 6.07685 9.96118 6.11662",
    stroke: "#2F80ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5665 6.11662C10.5666 6.07685 10.5588 6.03744 10.5436 6.00068C10.5285 5.96391 10.5062 5.9305 10.478 5.90237C10.4499 5.87425 10.4165 5.85196 10.3797 5.83679C10.343 5.82162 10.3036 5.81386 10.2638 5.81397",
    stroke: "#2F80ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5276 8.18615C17.5276 14.5621 11.9328 18.1383 10.5632 18.9204C10.4719 18.9726 10.3685 19 10.2634 19C10.1582 19 10.0549 18.9726 9.96355 18.9204C8.59392 18.1375 3 14.5605 3 8.18615C3 6.25967 3.76529 4.4121 5.12751 3.04988C6.48974 1.68765 8.33731 0.922363 10.2638 0.922363C12.1903 0.922363 14.0378 1.68765 15.4001 3.04988C16.7623 4.4121 17.5276 6.25967 17.5276 8.18615Z",
    stroke: "#2F80ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverityInfo);
export default __webpack_public_path__ + "static/media/SeverityInfo.96895c26ef85ee82adde58bc17fd828d.svg";
export { ForwardRef as ReactComponent };